module.exports = __webpack_public_path__ + "static/img/bg-fr.c2edf4a6.webp";